import Modal from "src/components/common/modal";
import { weekDays, getDateEndFromWeekNum } from "src/components/common/functions";

export default function OutsideBackupHistory({
    backups,
    week,
    targetName,
    closeIt,
    restoreBackup,
    currentWeekStatus = "",
}){
    const restoreLocked = ["Submitted", "Approved"].includes(currentWeekStatus);
    const restoreLockedStatus = currentWeekStatus ? currentWeekStatus.toLowerCase() : "submitted";
    const workSummary = backup => {
        const summaries = backup.summary?.dayWorkSummaries || [];
        if(summaries.length){
            const visibleSummaries = summaries
                .map((day, index) => ({...day, dayName: weekDays[index]}))
                .filter(day => day.ticketCount || day.otherCount || day.dayStatus !== "Created");
            if(!visibleSummaries.length) return "No work recorded";
            return visibleSummaries.map(day => {
                const ticketText = `${day.ticketCount || 0} ${(day.ticketCount || 0) === 1 ? "ticket" : "tickets"}`;
                const otherText = day.otherCount ? `, ${day.otherCount} other` : "";
                const dayStatusText = day.dayStatus && day.dayStatus !== "Created" ? ` (${day.dayStatus})` : "";
                return `${day.dayName}: ${day.workStatus || "No Work"} - ${ticketText}${otherText}${dayStatusText}`;
            }).join(" | ");
        }

        const statuses = backup.summary?.dayStatuses || [];
        if(!statuses.length) return "No work recorded";
        return statuses.map((status, index) => `${weekDays[index]}: ${status}`).join(" | ");
    };
    const formatDateParts = date => {
        const hour = date.getHours();
        const hour12 = hour % 12 || 12;
        const amPm = hour >= 12 ? "PM" : "AM";
        return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${String(date.getFullYear()).slice(-2)} ${String(hour12).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")} ${amPm}`;
    };
    const formatSavedAt = backup => {
        if(backup?.time_created_unix){
            return formatDateParts(new Date(Number(backup.time_created_unix) * 1000));
        }
        const savedAt = backup?.time_created;
        if(!savedAt) return "";
        const [datePart, timePart = "00:00:00"] = savedAt.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hour = 0, minute = 0] = timePart.split(":").map(Number);
        if(!year || !month || !day) return savedAt;

        return formatDateParts(new Date(year, month - 1, day, hour, minute));
    };

    return(
        <Modal
            title = {`View Save History - ${getDateEndFromWeekNum(week)}${targetName ? ` - ${targetName}` : ""}`}
            closeIt = {closeIt}
            touchOutsideClose = {true}
            width = {"70rem"}
            maxWidth = "100%"
            formFormat = ""
        >
            <div className = "w-100 py-3">
                {restoreLocked?
                <div className = "alert alert-warning">
                    This week is {restoreLockedStatus}. Restore is not available, but save history can still be viewed.
                </div>
                :null}
                {!backups.length?
                <div className = "alert alert-info mb-0">
                    No save history found for this week.
                </div>
                :
                <div className = "table-responsive">
                    <table className = "table table-sm table-striped tableAllBorder mb-0">
                        <thead>
                            <tr>
                                <th>Saved At</th>
                                <th>Work Summary</th>
                                <th>Emergencies</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {backups.map(backup =>
                            <tr key = {backup.id}>
                                <td className = "text-nowrap">
                                    <div>{formatSavedAt(backup)}</div>
                                    {backup.save_label?
                                    <div className = "small font-weight-bold text-primary">{backup.save_label}</div>
                                    :null}
                                </td>
                                <td>{workSummary(backup)}</td>
                                <td>{backup.summary?.emergencyCount ?? 0}</td>
                                <td>
                                    {restoreLocked?
                                    <span className = "text-muted">Not available</span>
                                    :
                                    <button
                                        type = "button"
                                        className = "btn btn-warning btn-sm"
                                        disabled = {backup.summary?.valid === false}
                                        onClick = {() => restoreBackup(backup)}
                                    >
                                        Restore
                                    </button>}
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>}
            </div>
        </Modal>
    );
}
